module.exports = __webpack_public_path__ + "img/1ANV_logo_white.bc3df588.png";